var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "header" },
    [
      _c("div", { staticClass: "header-left" }, [
        _c(
          "h1",
          {
            staticStyle: { cursor: "pointer" },
            on: { click: _vm.changeCollapse }
          },
          [_vm._v("电仪EITPM决策管理平台")]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "header-right" }, [
        _c(
          "div",
          { staticClass: "header-user-con" },
          [
            _c(
              "div",
              {
                staticClass: "btn-fullscreen",
                on: { click: _vm.handleFullScreen }
              },
              [
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      effect: "dark",
                      content: _vm.fullscreen ? "取消全屏" : "全屏",
                      placement: "bottom"
                    }
                  },
                  [_c("i", { staticClass: "el-icon-rank" })]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "btn-bell" },
              [
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      effect: "dark",
                      content:
                        _vm.message > 0
                          ? "有" + _vm.message + "条未读消息"
                          : "消息中心",
                      placement: "bottom"
                    }
                  },
                  [
                    _c("router-link", { attrs: { to: "/messageInfo" } }, [
                      _c("i", { staticClass: "el-icon-bell" })
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.message > 0
                  ? _c("span", { staticClass: "btn-bell-badge" })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _c(
              "el-dropdown",
              {
                staticClass: "user-name",
                attrs: { trigger: "click" },
                on: { command: _vm.handleCommand }
              },
              [
                _c("span", { staticClass: "el-dropdown-link" }, [
                  _vm._v("\n          " + _vm._s(_vm.username) + " "),
                  _c("i", { staticClass: "el-icon-caret-bottom" })
                ]),
                _vm._v(" "),
                _c(
                  "el-dropdown-menu",
                  { attrs: { slot: "dropdown" }, slot: "dropdown" },
                  [
                    _vm.userType == "NORMAL"
                      ? _c(
                          "el-dropdown-item",
                          { attrs: { command: "updatePwd" } },
                          [_vm._v("修改密码")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("el-dropdown-item", { attrs: { command: "loginout" } }, [
                      _vm._v("退出登录")
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "passDialog",
          attrs: { title: "修改密码", visible: _vm.passwordDialog },
          on: {
            "update:visible": function($event) {
              _vm.passwordDialog = $event
            },
            close: function($event) {
              _vm.closeDialog("passForm")
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "passForm",
              attrs: {
                model: _vm.passForm,
                rules: _vm.passwordRules,
                "label-width": "100px",
                "status-icon": ""
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "旧密码", prop: "oldPassword" } },
                [
                  _c("el-input", {
                    attrs: { type: "password", autocomplete: "off" },
                    model: {
                      value: _vm.passForm.oldPassword,
                      callback: function($$v) {
                        _vm.$set(_vm.passForm, "oldPassword", $$v)
                      },
                      expression: "passForm.oldPassword "
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "新密码", prop: "newPassword" } },
                [
                  _c("el-input", {
                    attrs: { type: "password", autocomplete: "off" },
                    model: {
                      value: _vm.passForm.newPassword,
                      callback: function($$v) {
                        _vm.$set(_vm.passForm, "newPassword", $$v)
                      },
                      expression: "passForm.newPassword"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "确认新密码", prop: "checkNewPass" } },
                [
                  _c("el-input", {
                    attrs: { type: "password", autocomplete: "off" },
                    model: {
                      value: _vm.passForm.checkNewPass,
                      callback: function($$v) {
                        _vm.$set(_vm.passForm, "checkNewPass", $$v)
                      },
                      expression: "passForm.checkNewPass"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.passwordDialog = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.submitPassForm }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "user-avator" }, [
      _c("img", { attrs: { src: require("@/assets/images/avatar.jpg") } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2ef0d2d5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ef0d2d5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/components/HeadBar.vue
// module id = null
// module chunks = 